import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/store';
import cpr from './CPR';
import ch1 from './CH1';
import admin from './Admin';
import CH2 from './CH2';
import v3CH1 from './v3CH1';
import v3CH2 from './v3CH2';
//v4
import v4CH1 from './v4CH1';
import v4CH2 from './v4CH2';
import v4CPR from './v4CPR';

// import {component} from 'vue/types/umd';
// Containers
const TheContainer = () => import('@/containers/TheContainer');

// Mdl pages
const Homepage = () => import('@/view/HomePage');
const MainProfile = () => import('@/view/AccountManagement');
const SearchResult = () => import('@/view/SearchResult');
const Overview = () => import('@/view/Overview');
const Swiper = () => import('@/components/screen/Swiper');
const Learningprofile = () => import('@/components/screen/LearningProfile');
const InprogressCourseDetail = () =>
  import('@/components/screen/InprogressCourseDetail');
const NotFound = () => import('@/view/NotFound');
const UploadVideo = () => import('@/view/UploadVideo');
const Register = () => import('@/view/RegisterMoodle');
// testing route
const Testing = () => import('@/view/TestingSingleCourse');
const TemplateV3 = () => import('@/view/v3/v3DisplayPage');
const SSOCallBack = () => import('@/components/authentication/SSOCallBack');

Vue.use(Router);
// Check sign in or not
// Logged in
const checkLangOption = (to, from, next) => {
  store.dispatch('template/setLangOption', false);
  next();
  return;
};
const ifAuthenticated = (to, from, next) => {
  if (store.getters['auth/userStatus']) {
    checkLangOption(to, from, next);
  } else {
    next('/homepage');
  }
};

export default new Router({
  // https://router.vuejs.org/api/#mode
  mode: 'hash', //hash or history
  linkActiveClass: 'active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    ...configRoutes(),
    ...cpr,
    ...ch1,
    ...admin,
    ...CH2,
    // ...v3CH1,
    // ...v3CH2,
    ...v4CH1,
    ...v4CH2,
    ...v4CPR,
  ],
});

function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/homepage',
      name: 'Home',
      component: Homepage,
      beforeEnter: checkLangOption,
    },
    {
      path: '/homepage',
      name: 'Homepage',
      component: Homepage,
      beforeEnter: checkLangOption,
    },
    {
      path: '/registerMoodle/:courseCode',
      name: 'registerMoodle',
      component: Register,
      beforeEnter: checkLangOption,
    },
    {
      path: '/MainProfile/:signal',
      name: 'MainProfile',
      component: MainProfile,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/Overview/:courseObjectId',
      name: 'Overview',
      component: Overview,
      beforeEnter: checkLangOption,
    },
    {
      path: '/Learningprofile',
      name: '/Learningprofile',
      component: Learningprofile,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/InprogressCourseDetail',
      name: '/InprogressCourseDetail',
      component: InprogressCourseDetail,
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/SearchResult',
      name: 'SearchResult',
      component: SearchResult,
      beforeEnter: checkLangOption,
    },
    {
      path: '/Testing',
      name: 'Testing',
      component: Testing,
      beforeEnter: checkLangOption,
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound,
    },
    {
      path: '/upload-video',
      name: 'UploadVideo',
      component: UploadVideo,
    },
    {
      path: '/display/:contentId',
      name: 'TemplateV3',
      component: TemplateV3,
    },
    {
      path: '/auth/callback',
      name: 'AuthCallBack',
      component: SSOCallBack,
    },
  ];
}
